var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrGradientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.548828 9.24112H9.45205V0.337891H0.548828V9.24112ZM2.77463 2.5637H7.22625V7.01531H2.77463V2.5637ZM0.548828 20.3701H9.45205V11.4669H0.548828V20.3701ZM2.77463 13.6927H7.22625V18.1443H2.77463V13.6927ZM11.6779 0.337891V9.24112H20.5811V0.337891H11.6779ZM18.3553 7.01531H13.9037V2.5637H18.3553V7.01531ZM11.689 11.4669H13.9148V13.6927H11.689V11.4669ZM13.9148 13.6927H16.1406V15.9185H13.9148V13.6927ZM11.689 15.9185H13.9148V18.1443H11.689V15.9185ZM16.1406 15.9185H18.3664V18.1443H16.1406V15.9185ZM18.3664 18.1443H20.5922V20.3701H18.3664V18.1443ZM13.9148 18.1443H16.1406V20.3701H13.9148V18.1443ZM16.1406 11.4669H18.3664V13.6927H16.1406V11.4669ZM18.3664 13.6927H20.5922V15.9185H18.3664V13.6927Z",
    fill: "url(#paint0_linear_4847_63871)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4847_63871",
    x1: 0.548828,
    y1: 0.337891,
    x2: 21.0009,
    y2: 0.764166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE594"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrGradientIcon);
export default __webpack_public_path__ + "static/media/qr-gradient-icon.92e85d92bc6c64e533b8126989fbc64b.svg";
export { ForwardRef as ReactComponent };